import { PATIENT_SERVICES } from '@avanta/shared/constants/patients';
import { UserType } from '@avanta/shared/constants/users';
import { type ReactElement } from 'react';
import { Navigate } from 'react-router';
import { ROUTES } from 'constants/routes';
import { Pae } from 'pages/Pae';
import { useIsPatient, useIsPatientOrEmployee, useUserStore } from 'stores/user';
import { PsychologistHome } from './components/PsychologistHome';

const HomeComponent = {
  [UserType.PSYCHOLOGIST]: <PsychologistHome />,
};

const ServicesComponents = {
  [PATIENT_SERVICES.PAE]: <Navigate to={ROUTES.PAE} replace />,
  [PATIENT_SERVICES.SAPA]: <Navigate to={ROUTES.SAPA} replace />,
};

export const Home = (): ReactElement => {
  const user = useUserStore(state => state.user);
  const isPatient = useIsPatient();
  const Component = HomeComponent[user?.type as keyof typeof HomeComponent];
  const usersWithActiveServices = useIsPatientOrEmployee();
  const activeServices = user?.activeServices;

  if (isPatient) {
    return <Pae />;
  }

  if (usersWithActiveServices && activeServices && activeServices?.length >= 1) {
    const [singleService] = activeServices;
    return ServicesComponents[singleService as keyof typeof ServicesComponents];
  }

  if (user?.type === UserType.SUPPORTER) {
    return <Navigate to={ROUTES.CHAT} replace />;
  }

  return Component;
};
